export default __webpack_public_path__ + "static/realWorldImg4-349a2102734f08ee68847c0ee31abb3f.png";